import script from "./ModalIAIndisponivel.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalIAIndisponivel.vue?vue&type=script&setup=true&lang=js"

import "./ModalIAIndisponivel.vue?vue&type=style&index=0&id=257493e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-257493e9"]])

export default __exports__